import { useContext } from "react";

import { ChooseAsset } from "./ChooseAsset";
import { CompleteAssetCreation } from "./CompleteAssetCreation";
import { ConfigureAsset } from "./ConfigureAsset";
import { CreateAsset } from "./CreateAsset";

import type { Video } from "vimeo";
import type { Step } from "./Footer";
import EmbedInEmailContext from "../../contexts/embedInEmailContext";

export interface Props {
    video: Video;
    selectedStep: Step;
    onComplete: () => void;
    hideAssetSelection?: boolean;
}

export function Body(props: Props) {
    const { selectedStep, onComplete, hideAssetSelection } = props;
    const [embedInEmailContextState, _setEmbedInEmailContextState] =
        useContext(EmbedInEmailContext);

    return (
        <div className="slds-var-p-around_large" style={{ width: "100%" }}>
            {!hideAssetSelection && selectedStep.value === "choose-asset" && (
                <ChooseAsset uri={props.video.uri} name={props.video.name} />
            )}
            {selectedStep.value === "configure-asset" && (
                <ConfigureAsset defaultVideoLink={props.video.link} />
            )}
            {selectedStep.value === "create-asset" && (
                <CreateAsset onComplete={onComplete} />
            )}
            {selectedStep.value === "success" && (
                <CompleteAssetCreation
                    imgUrl={
                        embedInEmailContextState.createAssetWithPlayButton
                            ? embedInEmailContextState.imgUrlWithPlayButton!
                            : embedInEmailContextState.imgUrl!
                    }
                    title={props.video.name}
                />
            )}
        </div>
    );
}
